export enum AppConstants_Design {
  BTNTYPE_PRIMARY = 'primary',
  BTNTYPE_SECONDARY = 'secondary',
  BTNTYPE_DANGER = 'danger',
  BTNTYPE_DISABLE = 'disable',
  COMPANYID = 'NS',
}
